export default __webpack_public_path__ + "assets/abkhazia-flag.png";